<template>
  <div class="resources--root">
      <h2 class="ui header">
        My Submitted Events
      </h2>
    <table class="ui compact celled definition table">
      <thead class="full-width">
        <tr>
          <th>Event</th>
          <th>Organizer</th>
          <th>Location</th>
          <th>Category</th>
          <th>Submitted At</th>
          <th>Statues</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(resource, idx) in events" :key="idx">
          <td>
            <h4 class="ui image header">
                <img :src="resource.event_logo" class="ui mini rounded image">
                <div class="content">
                  <router-link :to="'/dashboard/events/' + resource.ID">
                    {{ resource.post_title }}
                  </router-link>
                <div class="sub header">
                  {{  resource.start_date }} <span v-if="resource.end_date"> - {{ resource.end_date }}</span>
                </div>
                <div>
                  <a :href="resource.permalink" target="_blank" v-show="resource.post_status === 'publish'" class="view--on--website--btn">
                View <i class="external alternate icon"></i>
                </a>
                </div>
              </div>
            </h4>
          </td>
          <td>
            <span v-for="(org, i) in resource.organizer" :key="i">
              {{ org.name }} <span v-if="i < resource.organizer.length - 1">,</span>
            </span>
          </td>
          <td>
            <span v-for="(loc, i) in resource.location" :key="i">
              {{ loc.name }} <span v-if="i < resource.location.length - 1">,</span>
            </span>
          </td>
          <td>
            <span v-for="(cat, i) in resource.category" :key="i">
              {{ cat.name }} <span v-if="i < resource.category.length - 1">,</span>
            </span>
          </td>
          <td>{{ resource.post_date }}</td>
          <td class="negative" v-show="resource.post_status === 'rejected'"><i class="icon close"></i> Rejected</td>
          <td class="positive" v-show="resource.post_status === 'publish'"><i class="icon checkmark"></i> Approved</td>
          <td class="warning" v-show="resource.post_status === 'pending'"><i class="attention icon"></i> Pending Approval
          </td>
          <td class="collapsing">
            <!-- <div class="ui icon buttons">
              <button @click="moveToEdit(resource)" class="positive ui small button sc--tooltip" data-content="Edit" data-variation="mini">Edit <i class="edit icon"></i></button>
            </div> -->
          </td>
        </tr>
        <tr v-if="events.length === 0">
            <p class="warning message sc--no--resources--msg">
              No Events , Add Some
            </p>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th></th>
          <th colspan="6">
            <router-link class="ui right floated small labeled icon button sc--btn add--resource--btn" to="/dashboard/add-event">
              <i class="plus icon"></i> Add Event
            </router-link>
          </th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ResourcesPage',
  data() {
    return {
      resources: [],
      events: [],
    };
  },
  created() {
    this.fetchEvents();
    this.fetchCurrentUser();
  },
  methods: {
    moveToEdit(res) {
      localStorage.setItem('cn_t_nt', res.post_content);
      this.$router.push('/dashboard/events/' + res.ID + '/edit');
    },
    async fetchEvents() {
      try {
        const response = await fetch('/wp-json/custom/v1/my-events?k__sjnb__sdfjn0547=' + localStorage.getItem('sjdifjsckdsjfosdf54520zzz') + '', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        const responseData = await response.json();

        if (response.ok && responseData.success) {
          this.events = responseData.events;
        } else {
          console.error('Failed to fetch events:', responseData);
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },
    fetchCurrentUser() {
      fetch('//wp-json/wp/v2/users/me', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      }).then(response => response.json())
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          console.error('An error occurred:', error);
        });
    },
  },
}
</script>

<style scoped lang="sass">
  .sc--btn
    min-width: auto
    color: #fff !important
    background: #D0AE18 !important

  .view--on--website--btn
    font-size: 12px
    font-weight: normal

  tr:hover
    background: #f9fafb
</style>